<template>
  <section class="bg-gray-50 py-16 sm:py-24">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="lg:grid lg:grid-cols-2 lg:items-center lg:gap-16">
        <div class="text-center lg:text-left">
          <span class="section-badge">O spoločnosti</span>
          <h2 class="section-title mt-4 lg:mx-0">
            Dodáme riešenie na mieru
          </h2>
          <p class="mt-4 text-lg leading-7 text-gray-600 lg:max-w-lg">
            Himalia je spoločnosť poskytujúca profesionálne služby v oblastiach
            softwarového a hardwarového vývoja, integrácie, podpory a
            konzultácií.
          </p>
          <img
            src="@/assets/undraw_Designer_by46.svg"
            alt=""
            class="mx-auto mt-10 max-w-xs lg:mx-0 lg:max-w-sm"
          />
        </div>

        <dl class="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-3 lg:mt-0">
          <div
            v-for="stat in stats"
            :key="stat.label"
            class="card-surface flex flex-col items-center p-6 text-center sm:items-start sm:text-left"
          >
            <dd
              class="text-4xl font-extrabold tracking-tight text-brand-600 sm:text-5xl"
            >
              {{ stat.value }}
            </dd>
            <dt class="mt-2 text-sm font-medium text-gray-600">
              {{ stat.label }}
            </dt>
          </div>
        </dl>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  setup() {
    return {
      stats: [
        { value: "10+", label: "rokov skúseností v IT" },
        { value: "24/7", label: "podpora systémov" },
        { value: "2M+", label: "riadkov kódu" },
      ],
    };
  },
};
</script>
